export const TranslationIdMap = '';

export const TranslationKeyMap = {
    '_9996_TRANSCRIPTS': 'Transcripts',
    '_11211_BACK': 'Back',
    '_10020_SAVE': 'Save',
    '_9977_EXPAND': 'Expand',
    '_9978_COLLAPSE': 'Collapse',
    '_763_CLOSE': 'Close',
    '_10058_CREATED_ON_': 'Created on:',
    '_10056_TRANSCRIPT_SAVED': 'Transcript Saved'
};
